import { fetchPictogramLayerStatuses } from "../api/pictogram-layers.api";

export async function getPictogramLayerStatuses(layerId, params = {}) {
  try {
    const response = await fetchPictogramLayerStatuses(layerId, params);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los estados de la capa: ', error);
    throw error;
  }
}
